<template>
  <div>
    <div v-if="isQuotationStage">
      <BaseAlert
        color="var(--red-100)"
        class="border-sm border-solid border-error"
        v-if="quoteFailed"
      >
        <div class="d-flex flex-no-wrap error-message">
          <div class="mr-3">
            <v-icon color="var(--red-500)">mdi-alert-circle</v-icon>
          </div>
          <div class="primary--text">
            <span class="font-weight-bold">Sorry!</span>
            We couldn't get a quote right now, please try again in a few
            minutes.
          </div>
        </div>
      </BaseAlert>
      <BaseAlert
        color="var(--red-100)"
        class="border-sm border-solid border-error"
        v-if="quoteDeclined"
      >
        <div class="d-flex flex-no-wrap error-message">
          <div class="mr-3">
            <v-icon color="var(--red-500)">mdi-alert-circle</v-icon>
          </div>
          <div class="primary--text">
            <span class="font-weight-bold">Sorry!</span> Unfortunately no
            insurer was able to offer you a quote at this time based on the
            details you have entered.
          </div>
        </div>
      </BaseAlert>
      <BaseAlert
        color="var(--red-100)"
        class="border-sm border-solid border-error"
        v-if="clientError"
      >
        <div class="d-flex flex-no-wrap error-message">
          <div class="mr-3">
            <v-icon color="var(--red-500)">mdi-alert-circle</v-icon>
          </div>
          <div class="primary--text">
            <span class="font-weight-bold">Sorry!</span> There is a problem with
            the following questions:
            <ul>
              <li
                v-for="(message, index) in clientErrorMessagesArray"
                :key="index"
                class="font-weight-bold"
              >
                {{ message }}
              </li>
            </ul>
          </div>
        </div>
      </BaseAlert>
    </div>
    <div v-else>
      <BaseAlert
        v-if="paymentErrorMessage.length"
        color="var(--red-100)"
        class="pa-4 border-sm border-solid border-error"
      >
        <div
          class="d-flex flex-no-wrap error-message"
          v-if="Array.isArray(paymentErrorMessage)"
        >
          <div class="mr-3">
            <v-icon color="var(--red-500)">mdi-alert-circle</v-icon>
          </div>
          <div class="primary--text">
            <span class="font-weight-bold">Sorry!</span> There is a problem with
            the following questions:
            <ul>
              <li
                v-for="(message, index) in paymentErrorMessage"
                :key="index"
                class="font-weight-bold"
              >
                {{ message }}
              </li>
            </ul>
          </div>
        </div>
        <div class="d-flex" v-else>
          <div class="mr-3">
            <v-icon color="var(--red-500)">mdi-alert-circle</v-icon>
          </div>
          <div class="primary--text">
            <span v-html="paymentErrorMessage"></span>
          </div>
        </div>
      </BaseAlert>
    </div>
  </div>
</template>

<script>
import { CLIENTERROR, FAILED, UNABLE } from "@/constants/common.constants";
import {
  APPLICATION_MODULE,
  QUESTIONS_MODULE,
} from "@/store/types/module-types";
import { mapGetters, mapState } from "vuex";

export default {
  name: "QuoteErrorAlert",
  components: {
    BaseAlert: () => import("@/components/BaseComponents/BaseAlert.vue"),
  },
  props: {
    isQuotationStage: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState(QUESTIONS_MODULE, { lastQuoteErrorType: "lastQuoteErrorType" }),
    ...mapState(APPLICATION_MODULE, {
      paymentErrorMessage: "paymentErrorMessage",
    }),
    ...mapGetters(QUESTIONS_MODULE, {
      clientErrorMessagesArray: "clientErrorMessagesArray",
    }),
    quoteFailed() {
      return this.lastQuoteErrorType === FAILED;
    },
    quoteDeclined() {
      return this.lastQuoteErrorType === UNABLE;
    },
    clientError() {
      return this.lastQuoteErrorType === CLIENTERROR;
    },
  },
};
</script>
